__turbopack_context__.v({
  "blink": "Ifd_Na_blink",
  "dash": "Ifd_Na_dash",
  "dotGrid": "Ifd_Na_dotGrid",
  "draw": "Ifd_Na_draw",
  "enter": "Ifd_Na_enter",
  "fade": "Ifd_Na_fade",
  "float": "Ifd_Na_float",
  "flowDash": "Ifd_Na_flowDash",
  "glow": "Ifd_Na_glow",
  "grow": "Ifd_Na_grow",
  "heal": "Ifd_Na_heal",
  "healScan": "Ifd_Na_healScan",
  "label": "Ifd_Na_label",
  "lift": "Ifd_Na_lift",
  "motion": "Ifd_Na_motion",
  "pop": "Ifd_Na_pop",
  "pulse": "Ifd_Na_pulse",
  "revealOnce": "Ifd_Na_revealOnce",
  "scan": "Ifd_Na_scan",
  "shimmer": "Ifd_Na_shimmer",
  "tick": "Ifd_Na_tick",
  "tickLead": "Ifd_Na_tickLead",
  "wave": "Ifd_Na_wave",
});
